import React, { useState } from 'react';
import { Amount, Box, Link, Text } from '@razorpay/blade/components';
import type { EditPayrollListItem } from './types';
import { formatOvertimeEntryQuantity } from './overtimeFormat';
import { useOvertimePreview } from './useOvertimePreview';

export interface OvertimeColumnCellProps {
  entries: EditPayrollListItem['overtime']['entries'];
  userId: EditPayrollListItem['forPeopleId'];
  payrollMonth: EditPayrollListItem['overtimePayrollMonth'];
}

const OvertimeColumnCell = ({ entries, userId, payrollMonth }: OvertimeColumnCellProps) => {
  const [isCalculated, setIsCalculated] = useState(false);
  const { total, isLoading } = useOvertimePreview({
    entries,
    userId: userId ?? null,
    payrollMonth: payrollMonth ?? '',
    enabled: isCalculated,
  });

  const quantity = entries.map(formatOvertimeEntryQuantity).filter(Boolean).join(' · ');

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-end" gap="spacing.2">
      {quantity ? (
        <Text variant="caption" size="small" color="surface.text.gray.muted">
          {quantity}
        </Text>
      ) : null}
      {isCalculated ? (
        isLoading ? (
          <Text variant="caption" size="small" color="surface.text.gray.muted">
            Calculating…
          </Text>
        ) : total !== null ? (
          <Amount value={total} size="small" />
        ) : (
          <Text>-</Text>
        )
      ) : (
        <Link
          size="small"
          variant="button"
          accessibilityLabel="Calculate overtime amount"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsCalculated(true);
          }}>
          Calculate
        </Link>
      )}
    </Box>
  );
};

export { OvertimeColumnCell };
